var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1000002886(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 16.7712C10.5415 17.5651 9.89791 18.2087 9.104 18.2087C8.31009 18.2087 7.6665 17.5651 7.6665 16.7712C7.6665 15.9773 8.31009 15.3337 9.104 15.3337C9.89791 15.3337 10.5415 15.9773 10.5415 16.7712Z",
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 11.5C10.5415 12.2939 9.89791 12.9375 9.104 12.9375C8.31009 12.9375 7.6665 12.2939 7.6665 11.5C7.6665 10.7061 8.31009 10.0625 9.104 10.0625C9.89791 10.0625 10.5415 10.7061 10.5415 11.5Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5415 6.22876C10.5415 7.02267 9.89791 7.66626 9.104 7.66626C8.31009 7.66626 7.6665 7.02267 7.6665 6.22876C7.6665 5.43485 8.31009 4.79126 9.104 4.79126C9.89791 4.79126 10.5415 5.43485 10.5415 6.22876Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 16.7712C15.3335 17.5651 14.6899 18.2087 13.896 18.2087C13.1021 18.2087 12.4585 17.5651 12.4585 16.7712C12.4585 15.9773 13.1021 15.3337 13.896 15.3337C14.6899 15.3337 15.3335 15.9773 15.3335 16.7712Z",
    fill: "#001B4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 11.5C15.3335 12.2939 14.6899 12.9375 13.896 12.9375C13.1021 12.9375 12.4585 12.2939 12.4585 11.5C12.4585 10.7061 13.1021 10.0625 13.896 10.0625C14.6899 10.0625 15.3335 10.7061 15.3335 11.5Z",
    fill: "#001B4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 6.22876C15.3335 7.02267 14.6899 7.66626 13.896 7.66626C13.1021 7.66626 12.4585 7.02267 12.4585 6.22876C12.4585 5.43485 13.1021 4.79126 13.896 4.79126C14.6899 4.79126 15.3335 5.43485 15.3335 6.22876Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000002886);
export default __webpack_public_path__ + "static/media/Frame 1000002886.90f779a6fa8ebf9f5f49f9f8e5344273.svg";
export { ForwardRef as ReactComponent };